import {
  FormProvider,
  type SubmitHandler,
  useFieldArray,
  useForm,
} from "react-hook-form";
import CabinList from "src/components/pages/Settings/YachtSetUp/CabinList/CabinList";
import YachtSetupSectionHeader from "src/components/pages/Settings/YachtSetUp/YachtSetupSectionHeader";
import Loader from "src/components/shared/Loader/Loader";
import { useCheckPerm, useGetApi, usePostApi } from "src/hooks";
import { PageContainer } from "src/styled";
import { getYachtId } from "src/utils";
import { Notification } from "src/utils/Notification";

interface ICabinForm {
  cabins: Array<{ name: string }>;
}

const mapCabins = (data: any) => {
  const cabins = data?.data?.content?.data?.cabins;
  if (!cabins) return [];
  return cabins.map((c: string) => ({ name: c }));
};

const CabinArrangement = () => {
  const checkPerm = useCheckPerm();

  const { data, isLoading: isGetLoading } = useGetApi({
    request: "get-settings",
    body: { params: { sect: "_cabins" } },
    mapper: mapCabins,
  });

  const { post, isLoading: isPostLoading } = usePostApi();

  const methods = useForm<ICabinForm>({ values: { cabins: data } });

  const { append, ...fieldArrayProps } = useFieldArray<ICabinForm>({
    control: methods.control,
    name: "cabins",
  });

  const handleAppend = () => {
    append({ name: "" });
  };

  const onSubmit: SubmitHandler<ICabinForm> = async data => {
    const params = {
      data: data.cabins.map(cabin => cabin.name),
      section: "cabins",
      yachtid: getYachtId(),
    };

    await post({
      request: "save-yacht-info",
      body: { params },
      onSuccess: () => {
        methods.reset(data);
        Notification(
          "Success",
          "Cabins have been successfully changed.",
          "green",
        );
      },
    });
  };

  return (
    <PageContainer>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <YachtSetupSectionHeader
            onAdd={handleAppend}
            canSave={checkPerm("editspecifics")}
            isSaving={isPostLoading}
            section="cabins"
          />
          {!data || isGetLoading ? (
            <Loader />
          ) : (
            <CabinList {...fieldArrayProps} />
          )}
        </form>
      </FormProvider>
    </PageContainer>
  );
};

export default CabinArrangement;
